import { ReactNode } from "react";

export interface PlanningError {
  driverId: string;
  driverName: string;
  message: string;
}

export const extractBulletPoints = (message: string): string[] => {
  return message.match(/•[^\n]+/g) || [];
};

export const calculateTotalOrders = (errors: PlanningError[]): number => {
  return errors.reduce((count, err) => {
    const matches = err.message.match(/order \d+/gi);
    return count + (matches ? matches.length : 0);
  }, 0);
};

export const buildErrorDialogContent = (errors: PlanningError[]): ReactNode => {
  const totalOrders = calculateTotalOrders(errors);
  
  const errorSections = errors.map((err, idx) => {
    const bulletPoints = extractBulletPoints(err.message);
    return (
      <div key={err.driverId} style={{ marginBottom: "16px" }}>
        <strong>
          Driver {idx + 1}: {err.driverName}
        </strong>
        <div style={{ marginLeft: "16px", marginTop: "4px" }}>
          {bulletPoints.length > 0 ? (
            bulletPoints.map((point, i) => (
              <div key={i} style={{ marginBottom: "2px" }}>
                {point}
              </div>
            ))
          ) : (
            <div>{err.message}</div>
          )}
        </div>
      </div>
    );
  });
  
  return (
    <div>
      <div style={{ marginBottom: "16px", fontWeight: "500" }}>
        {totalOrders} order(s) cannot be planned across {errors.length} driver(s).
      </div>
      {errorSections}
      <div style={{ marginTop: "16px" }}>
        Resolve these issues and try again.
      </div>
    </div>
  );
};